import React from 'react';
// import useSearchStore from '../_Global/SearchStore';
// import SpellingSuggestion from '../spelling-suggestion/SpellingSuggestion';
import ResultPeople from '../result-people/ResultPeople';
import ResultJob from '../result-job/ResultJob';
import ResultGlobal from '../result-global/ResultGlobal';
import ResultInsights from '../result-insights/ResultInsights';
import ResultNews from '../result-news/ResultNews';
import IconLoader from '../icons/jsx/IconLoader';

interface SearchResultsConfiguration {
    type: SearchType;
    results: SearchResult[];
}

function SearchResults({type, results}: SearchResultsConfiguration) {
    switch (type) {
        case 'people':
            return (
                <div className="grid gap-y-8 xs:gap-y-10 md:gap-y-12 lg:gap-y-16 xl:gap-y-20 xs:gap-x-4 sm:gap-x-6 grid-cols-4 xs:grid-cols-12">
                    {results.map((result) => {
                        return <ResultPeople key={result['rank']} result={result} />;
                    })}
                </div>
            );
        case 'insights':
            return (
                <div className="grid gap-y-8 xs:gap-y-10 md:gap-y-12 lg:gap-y-16 xl:gap-y-20 xs:gap-x-4 sm:gap-x-6 grid-cols-4 xs:grid-cols-12">
                    {results.map((result) => {
                        return <ResultInsights key={result['rank']} result={result} />;
                    })}
                </div>
            );
        case 'news':
            return (
                <div className="grid gap-y-8 xs:gap-y-10 md:gap-y-12 lg:gap-y-16 xl:gap-y-20 xs:gap-x-4 sm:gap-x-6 grid-cols-4 xs:grid-cols-12">
                    {results.map((result) => {
                        return <ResultNews key={result['rank']} result={result} />;
                    })}
                </div>
            );
        case 'jobs':
            return (
                <>
                    {results.map((result) => {
                        return <ResultJob key={result['rank']} result={result} />;
                    })}
                </>
            );
        default:
            // Default to global
            return (
                <>
                    {results.map((result) => {
                        return <ResultGlobal key={result['rank']} result={result} />;
                    })}
                </>
            );
    }
}

/**
 * Create the markup for the result tiles.
 * These will replace the placeholder results.
 */
export default React.memo(SearchResults);
